import { render, staticRenderFns } from "./personal-layout.vue?vue&type=template&id=21ade2c4&"
import script from "./personal-layout.vue?vue&type=script&lang=js&"
export * from "./personal-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports